<div class="oa-tabs" role="tablist" [attr.aria-label]="'STATISTICS' | translate">
  <button
    #tabButton
    *ngFor="let graph of graphList; let i = index"
    role="tab"
    type="button"
    class="oa-tab"
    [id]="'oa-tab-' + graph.id"
    [attr.aria-selected]="selectedGraph?.id === graph.id"
    [attr.aria-controls]="'oa-panel-' + graph.id"
    [tabindex]="selectedGraph?.id === graph.id ? 0 : -1"
    [class.oa-tab--active]="selectedGraph?.id === graph.id"
    (click)="changeGraph(graph.id)"
    (keydown)="onTabKeydown($event, i)"
    translate
  >{{ graph.translationKey }}</button>
</div>

<div
  class="oa-report-card"
  role="tabpanel"
  *ngIf="selectedGraph"
  [id]="'oa-panel-' + selectedGraph.id"
  [attr.aria-labelledby]="'oa-tab-' + selectedGraph.id"
>
  <ng-container *ngIf="!selectedGraph.showProductAnalyticsList; else showProductAnalyticsList">
    <div class="oa-report-head">
      <div class="oa-report-head__amount">
        <h3 class="oa-report-head__title">{{ selectedGraph.heading | translate }}</h3>
        <div class="oa-report-head__value">
          {{ selectedAmount | number: '1.0-0' }}
        </div>
      </div>
      <div class="oa-report-head__legend">
        <span class="oa-legend-item"><span class="oa-legend-dot oa-legend-dot--selected"></span>{{ 'SELECTED' | translate }}</span>
        <span class="oa-legend-item"><span class="oa-legend-dot oa-legend-dot--other"></span>{{ 'OTHERS' | translate }}</span>
      </div>
    </div>

    <lib-order-analytics-chart-table-horizontal
      [data]="data"
      [groupBy]="selectedGraph.groupBy"
      [heading]="selectedGraph.heading"
      [headerRows]="selectedGraph.headerRows"
      [hideVerticalGridLines]="selectedGraph.hideVerticalGridLines"
      [newTableLayout]="true"
      [selectedKey]="selectedKey"
      (selectedKeyChange)="selectedKey = $event"
      (selectedAmountChange)="selectedAmount = $event"
    />
  </ng-container>

  <ng-template #showProductAnalyticsList>
    <lib-filter-list [configService]="orderAnalyticsProductListConfigService"></lib-filter-list>
  </ng-template>
</div>

<div class="d-flex flex-row justify-content-center p-4" *ngIf="!selectedGraph">
  <i class="fa fa-spinner fa-spin fa-5x"></i>
</div>
